import {
  HashRouter,
  BrowserRouter,
  MemoryRouter,
  Router,
} from 'react-router-dom';
import { EmbedConfig } from 'features/EmbedConfig';
import {
  createHashHistory,
  createBrowserHistory,
  createMemoryHistory,
  HashType,
} from 'history';
import { RouterTypes } from './types';
import { createQueryHistory } from './createQueryHistory';

export const getRouterFromType = (routerType: string) => {
  switch (routerType) {
    case RouterTypes.HASH:
      return HashRouter;
    case RouterTypes.BROWSER:
      return BrowserRouter;
    case RouterTypes.MEMORY:
      return MemoryRouter;
    case RouterTypes.QUERY:
      // No stock react-router component for query mode: the low-level Router is
      // driven by the custom query history from getHistory.
      return Router;
    default:
      return HashRouter;
  }
};

const getHashType = (hashType: string): HashType => {
  if (
    hashType === 'slash' ||
    hashType === 'noslash' ||
    hashType === 'hashbang'
  ) {
    return hashType;
  }

  return 'hashbang';
};

export const getRouterOptions = (embedConfig: EmbedConfig) => {
  switch (embedConfig.routerType) {
    case 'hash':
      return {
        hashType: getHashType(embedConfig.hashType),
        basename: embedConfig.basePath,
      };
    case 'browser':
      return {
        basename: embedConfig.basePath,
        hashType: getHashType('noslash'),
      };
    case 'memory':
      return {};
    case 'query':
      // The custom query history owns everything; the Router takes only `history`.
      return {};
    default:
      return { hashType: getHashType('hashbang') };
  }
};

// The brand's home route is the experience list unless it is explicitly the
// calendar (data-home="calendar"), in which case the list stays addressable and
// does not collapse to the bare URL.
export const isExperienceListHome = (home?: string): boolean =>
  home !== 'calendar';

export const getHistory = (embedConfig: EmbedConfig) => {
  const config = getRouterOptions(embedConfig);

  switch (embedConfig.routerType) {
    case 'hash':
      return createHashHistory(config);
    case 'browser':
      return createBrowserHistory(config);
    case 'memory':
      return createMemoryHistory({});
    case 'query':
      return createQueryHistory({
        listIsHome: isExperienceListHome(embedConfig.home),
      });
    default:
      return createHashHistory(config);
  }
};
